module.exports = __webpack_public_path__ + "img/about-feature-202101.ec48137d.jpg";